import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {UserModel} from '../../../models/user.model';
import {PublicationModel} from '../../../models/publication.model';

@Component({
    selector: 'app-step-summary-registration',
    templateUrl: './step-summary-registration.component.html',
    styleUrls: ['./step-summary-registration.component.scss']
})
export class StepSummaryRegistrationComponent implements OnInit {

    sectionVisited: any = {
        first: true,
        second: false,
        third: false,
    };
    allSectionsVisited = false;

    @Output('onValidForm')
    onValidForm = new EventEmitter<boolean>();
    @Input() loggedUser: UserModel=new UserModel();
    @Input() publication: PublicationModel = new PublicationModel();
    @ViewChild('group1') group1;
    constructor() {
    }

    ngOnInit() {
    }

    onVisitSection(index: number) {
        switch (index) {
            case 1:
                this.sectionVisited.first = true;
                break;
            case 2:
                this.sectionVisited.second = true;
                break;
            case 3:
                this.sectionVisited.third = true;
                break;
        }

        if (this.sectionVisited.first && this.sectionVisited.second && this.sectionVisited.third) {
            this.onValidForm.emit(true);
        }

    }

    resetComponent() {
        this.sectionVisited.first = true;
        this.sectionVisited.second = false;
        this.sectionVisited.third = false;
        if(!this.group1.isOpen) {
            this.group1.toggleOpen();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/components/publication-registration/step-summary-registration/step-summary-registration.component.ts